// extracted by mini-css-extract-plugin
export default {"container":"LiveVideo_container__l8US7"};